import React from 'react';
import LocalizedMessage from 'react-l10n';

function TrackingNumber(props) {
    return (
        <div className='tracking-label tracking-label--data-table'>
            <div className='tracking-label__icon tracking-label__icon--main'>
                <span className='icon icon-freight-options' />
            </div>
            <div className='tracking-label__label'>
                <LocalizedMessage id={'TRACKING_NUMBER'} />
            </div>
            <div className='tracking-label__value'>{props.value}</div>
        </div>
    );
}

export default TrackingNumber;
